export class AudioTextPair {
    constructor() {
      this.texts = {}; // 储存 text 和对应的 audio_url 的映射，使用时间戳或唯一标识符作为键
      this.pendingTextIds = []; // 存储所有未配对的文本ID
      this.audioQueue = []; // 存储未配对的音频URL队列
    }
  
    // 接收 text 并准备接收 audio_url
    receiveText(text) {
      const timestamp = Date.now(); // 使用时间戳作为唯一标识符
      this.texts[timestamp] = { text, audio_url: null };
      this.pendingTextIds.push(timestamp);
      
      // 检查是否有待配对的音频
      if (this.audioQueue.length > 0) {
        const audio_url = this.audioQueue.shift();
        this.pairTextWithAudio(timestamp, audio_url);
      }
    }
  
    // 接收 audio_url 并与未配对的 text 配对
    receiveAudioUrl(audio_url) {
      // 如果有未配对的文本，则配对最早的一个
      if (this.pendingTextIds.length > 0) {
        const textId = this.pendingTextIds.shift();
        this.pairTextWithAudio(textId, audio_url);
      } else {
        // 如果没有未配对的文本，将音频加入队列等待
        this.audioQueue.push(audio_url);
      }
    }
  
    // 配对文本和音频
    pairTextWithAudio(textId, audio_url) {
      if (this.texts[textId] && this.texts[textId].audio_url === null) {
        this.texts[textId].audio_url = audio_url;
        console.log(`Paired audio_url ${audio_url} with the text received at ${textId}.`);
      }
    }
  
    // 通过 audio_url 获取对应的 text
    getTextByAudioUrl(audio_url) {
      for (let key in this.texts) {
        if (this.texts[key].audio_url === audio_url) {
          return this.texts[key].text;
        }
      }
      return null; // 如果没有找到匹配的 audio_url，则返回 null
    }
  
    // 获取所有已配对的 audio_url 和 text
    getAllPairs() {
      return Object.values(this.texts).filter((pair) => pair.audio_url !== null);
    }
  }